import { render } from "./WpeColor.vue?vue&type=template&id=88749ce0"
import script from "./WpeColor.vue?vue&type=script&lang=js"
export * from "./WpeColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88749ce0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88749ce0', __exports__)) {
    api.reload('88749ce0', __exports__)
  }
  
  module.hot.accept("./WpeColor.vue?vue&type=template&id=88749ce0", () => {
    api.rerender('88749ce0', render)
  })

}


export default __exports__